import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { getAppConfig } from '@/lib/env';
import globalCss from '@/styles/globals.css';
import EmbedFixedAgentClient from './agent-client';
const scriptTag = document.querySelector('script[data-agent-id]');
const agentIdAttribute = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.agentId;
// Derive the API base URL from the script's src attribute
const getScriptOrigin = () => {
    if (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.src) {
        try {
            const url = new URL(scriptTag.src);
            return url.origin;
        }
        catch (_a) {
            return window.location.origin;
        }
    }
    return window.location.origin;
};
const scriptOrigin = getScriptOrigin();
if (agentIdAttribute) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'voice-agent-embed-wrapper');
    document.body.appendChild(wrapper);
    // Use a shadow root so that any relevant css classes don't leak out and effect the broader page
    const shadowRoot = wrapper.attachShadow({ mode: 'open' });
    // Include all app styles into the shadow root
    const styleTag = document.createElement('style');
    styleTag.textContent = globalCss;
    shadowRoot.appendChild(styleTag);
    const reactRoot = document.createElement('div');
    shadowRoot.appendChild(reactRoot);
    getAppConfig(scriptOrigin, agentIdAttribute)
        .then((appConfig) => {
        // Pass the agentId to appConfig for use in connection details
        appConfig.agentId = agentIdAttribute;
        // Set the connection details endpoint based on script origin
        appConfig.connectionDetailsEndpoint = `${scriptOrigin}/api/connection-details`;
        const root = ReactDOM.createRoot(reactRoot);
        root.render(_jsx(EmbedFixedAgentClient, { appConfig: appConfig }));
    })
        .catch((err) => {
        console.error('Voice Agent embed error - Error loading app config:', err);
    });
}
else {
    console.error('Voice Agent embed error - no data-agent-id attribute found on script tag. This is required!');
}
